import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ApplyContextProvider } from './contexts/ApplyContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ApplyContextProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ApplyContextProvider>
    </React.StrictMode>
);
